import React, { useEffect, useState } from "react";
import {
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { getAccountDescription } from "../services/UserProfileApi";

const Describe = ({ accountType, error, describesMe, onDescribeMeChange }) => {
  const [accountDescribe, setAccountDescribe] = useState([]);

  useEffect(() => {
    if (!accountType || accountType === "unknown") return;
    getAccountDescription(accountType)
      .then((res) => setAccountDescribe(res.account_description || []))
      .catch((err) => console.error("Error fetching descriptions:", err));
  }, [accountType]);

  const handleChangeDescribeMe = (event) => {
    onDescribeMeChange(event.target.value);
  };

  return (
    <FormControl fullWidth margin="dense" required error={Boolean(error?.describes_me)}>
      <FormLabel sx={{mb:0.5}}>What describes me best?</FormLabel>
      <Select
        value={describesMe || ""}
        onChange={handleChangeDescribeMe}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}
        size="small"
      >
        <MenuItem value="" disabled>
          Select any one
        </MenuItem>
        {accountDescribe.map((item) => (
          <MenuItem key={item.id} value={item.description}>
            {item.description}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{error?.describes_me}</FormHelperText>
    </FormControl>
  );
};

export default Describe;